import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toPrecision',
    standalone: true
})
export class ToPrecisionPipe implements PipeTransform {

  transform(value: number, ...args: number[]): string {
    return this.precise(value, args);
  }

  precise(x, args: number[]) {
    // return Number(x.toPrecision(4));
    const roundedNumber  = Math.round(x * 10) / 10
    const precision = args.length > 0 ? args[0] : 1;
    return roundedNumber.toFixed(precision);
  }

}
